// Marketplace category structure + NZ regions

export interface MarketplaceCategory {
  value: string;
  label: string;
  subcategories: string[];
}

export const MARKETPLACE_CATEGORIES: MarketplaceCategory[] = [
  { value: 'boats', label: 'Boats', subcategories: ['Power boats', 'Sail boats', 'Jet boats', 'Trailer boats', 'Dinghies & tenders', 'Kayaks & canoes'] },
  { value: 'watercraft', label: 'Personal Watercraft', subcategories: ['Jet skis / PWCs', 'Water skis', 'Wakeboards', 'Kneeboards', 'Tubes'] },
  { value: 'motors', label: 'Motors & Engines', subcategories: ['Outboard motors', 'Inboard motors', 'Diesel engines', 'Parts & spares'] },
  { value: 'trailers', label: 'Trailers', subcategories: ['Boat trailers', 'Jet ski trailers', 'Trailer parts'] },
  { value: 'fishing', label: 'Fishing Gear', subcategories: ['Rods & reels', 'Tackle & lures', 'Nets & pots', 'Fish finders', 'Fishing kayaks'] },
  { value: 'electronics', label: 'Marine Electronics', subcategories: ['GPS & chartplotters', 'VHF radios', 'Sounders', 'Autopilots', 'Radar'] },
  { value: 'safety', label: 'Safety Equipment', subcategories: ['Lifejackets & PFDs', 'EPIRBs & PLBs', 'Flares', 'Life rafts', 'First aid'] },
  { value: 'water-sports', label: 'Water Sports & Diving', subcategories: ['Wetsuits', 'SUP boards', 'Diving gear', 'Kite surfing', 'Snorkelling'] },
  { value: 'anchoring', label: 'Anchoring & Mooring', subcategories: ['Anchors', 'Chain & rope', 'Fenders & buoys', 'Mooring gear'] },
  { value: 'sailing', label: 'Sailing Gear', subcategories: ['Sails', 'Rigging', 'Winches & blocks', 'Hardware'] },
  { value: 'chandlery', label: 'Marine Chandlery', subcategories: ['Paint & antifoul', 'Cleaning', 'Hardware', 'Plumbing', 'Electrical'] },
];

export const NZ_REGIONS = [
  'Auckland', 'Bay of Plenty', 'Canterbury', 'Coromandel', 'Far North',
  'Gisborne', "Hawke's Bay", 'Manawatu-Whanganui', 'Marlborough', 'Nelson',
  'Northland', 'Otago', 'Southland', 'Taranaki', 'Waikato', 'Wellington',
  'West Coast', 'Whangarei',
];

export const CONDITION_LABELS: Record<string, string> = {
  new: 'New',
  used: 'Used',
  refurbished: 'Refurbished',
  parts: 'Parts',
};

export function categoryLabel(value: string): string {
  return MARKETPLACE_CATEGORIES.find((c) => c.value === value)?.label || value;
}

export function formatPrice(price: number | string, priceType?: string): string {
  if (priceType === 'free') return 'Free';
  const n = typeof price === 'string' ? parseFloat(price) : price;
  if (!n || isNaN(n)) return priceType === 'negotiable' ? 'Negotiable' : 'POA';
  const formatted = n.toLocaleString('en-NZ', { style: 'currency', currency: 'NZD', maximumFractionDigits: 0 });
  return priceType === 'negotiable' ? `${formatted} neg.` : formatted;
}
